import request from '@/api/request'

/**
 * 获取合格证
 * @param page
 * @param limit
 */
export const printingCertificate = (params) => {
  return request({
    url: 'radioweb/adm/classStudent/printingCertificate',
    params,
    method: 'get'
  })
}
/**
 * 批量颁发结业证
 * @param page
 * @param limit
 */
export const awardGraduation = (data) => {
  return request({
    url: 'radioweb/adm/classStudent/awardGraduation',
    data,
    method: 'post'
  })
}
/**
 * 全部颁发结业证
 * @param page
 * @param limit
 */
export const awardAllGraduation = (data) => {
  return request({
    url: 'radioweb/adm/classStudent/awardAllGraduation',
    method: 'post',
    data
  })
}
/**
 * 批量删除结业证
 * @param page
 * @param limit
 */
export const delGraduation = (data) => {
  return request({
    url: 'radioweb/adm/classStudent/delGraduation',
    data,
    method: 'post'
  })
}
/**
 * 重新生成结业证
 * @param page
 * @param limit
 */
export const awardGraduationAgain = (data) => {
  return request({
    url: 'radioweb/adm/classStudent/awardGraduationAgain',
    data,
    method: 'post'
  })
}
/**
 * 增加套打次数
 */
export const addPlayTimes = (data) => {
  return request({
    url: 'radioweb/adm/classStudent/addPlayTimes',
    data,
    method: 'post'
  })
}
/**
 * 结业证
 */
export const exportBatchGraduation = (data) => {
  return request({
    url: 'radioweb/adm/classStudent/exportBatchGraduation',
    data,
    responseType: "arraybuffer",
    method: 'post'
  })
}
/**
 * 合格证
 */
export const exportBatchCertificate = (data) => {
  return request({
    url: 'radioweb/adm/classStudent/exportBatchCertificate',
    data,
    responseType: "arraybuffer",
    method: 'post'
  })
}
/**
 * 导出全部结业证
 */
export const exportAllGraduation = (data) => {
  return request({
    url: 'radioweb/adm/classStudent/exportAllGraduation',
    data,
    responseType: "arraybuffer",
    method: 'post'
  })
}
/**
 * 导出合格证
 */
export const exportAllCertificate = (data) => {
  return request({
    url: 'radioweb/adm/classStudent/exportAllCertificate',
    responseType: "arraybuffer",
    method: 'post',
    data
  })
}
